import React from 'react';
import cm from 'classnames';
import styles from '../_input.module.scss';

interface Props {
  className?: string;
  children?: React.ReactNode;
}

const InputHeader: React.FC<Props> = (props: Props) => {
  const { className, children } = props;
  const finalClassName = [styles.InputHeader];
  if (className) finalClassName.push(className);
  return <div className={cm(finalClassName)}>{children}</div>;
};

export { InputHeader };
